<template>
	<div class="qianyueBox">
		<h3 style="margin-bottom: 15px;">已签约商品(此处只展示非结算价商品)</h3>
    <!-- 展示非结算价 -->
    <div style="width: 100%;height: 50px;">
			<div class="block">
				<span class="demonstration">产品名：</span>
				<el-input style='width: 200px;' v-model="name" type="text" placeholder="产品名"></el-input>
			</div>

			<div class="block" style="margin-left:25px">
				<span class="demonstration">组编号：</span>
				<el-select v-model="productGroup" placeholder="请选择" size='small' clearable>
					<el-option v-for="item in productGrouplist"
                :key="item.code"
                :label="item.name"
                :value="item.code" ></el-option>
				</el-select>
        <el-button style="margin-left:25px" type="primary" @click='searchFun' size='small'>搜索</el-button>

        <div v-if=" prestore== 1" style="height: 35px;float: right;margin-left: 30px;line-height: 32px;">
          出单方式支付：
          <div style="display: inline-block;padding: 0px 23px;font-size: 14px;" :class="{act:actcolor == 0}" @click="actclick(0)">
            <span>正常支付</span>
          </div>
          <div style="display: inline-block;padding: 0px 23px;font-size: 14px;"  :class="{act:actcolor == 1}" @click="actclick(1)">
            <span>预存购买</span>
          </div>
          <div style="display: inline-block;padding: 0px 23px;font-size: 14px;"  :class="{act:actcolor == 2}" @click="actclick(2)">
            <span>不记名核销</span>
          </div>
        </div>
			</div>
    </div>
	<!-- <div class="shopBox"> -->
		<!-- <center class="cardBox">
			<h3 style="margin-top: 50px;">所有陈列商品二维码</h3>
			<p class="text1">
        <el-button type="primary" @click="downPdf">批量下载所有二维码</el-button>
      </p>
		</center>
			<div class="img">
				<ewm index='999' :imagePath=imagePath :channelId='channelId' :channelData='channelData' id='999' :subChannelId='subChannelId' :channelName="'thb'"></ewm>
        
			</div> -->
	<!-- </div> -->
	<!-- <div class="shopBox">
		<center class="cardBox">
			<h3>短期旅行救援服务</h3>
			<p class="text">7天/15天/30天 全球旅游个人安全保障</p>
      <p class="text1 yellow">￥39 ~ 139元</p>
		</center>
			<div class="img">
				<ewm index='888' :imagePath=imagePath :channelId='channelId' :channelData='channelData' id='888' :subChannelId='subChannelId' :hebing="'true'"></ewm>
			</div>
	</div> -->
	<!-- 不记名核销列表 -->
	<template v-if="actcolor == 2 && preOrderProductList.length != 0">
		<div style="background-color: #ffffff;">
			<div class="shopBox" style="margin-left: 20px;" v-for="(item,index) in preOrderProductList" :key="index">
				<!-- 如果未过期，显示二维码 -->
				<template v-if="!item.isExpired">
					<span v-if="item.product.productCode">
						<ewm :preOrder="true" :productCode="item.product.productCode" :billingId="item.billingId" :key="preOrderTime" :index=index :imagePath=imagePath :channelId='item.channelId || channelId' :channelData='channelData' :id='item.product.id' :productGroup='item.product.productGroup' :Grouptype='"bbbb"' :subChannelId='item.subChannelId || subChannelId' :type='item.product.introHtml'></ewm>
					</span>
					<span v-else>
						<ewm :preOrder="true" :billingId="item.billingId" :key="preOrderTime" :index=index :imagePath=imagePath :channelId='item.channelId || channelId' :channelData='channelData' :id='item.product.id' :productGroup='item.product.productGroup' :Grouptype='"bbbb"' :subChannelId='item.subChannelId || subChannelId' :type='item.product.introHtml'></ewm>
					</span>
				</template>
				<!-- 如果已过期，显示已过期提示 -->
				<div v-else class="img" style="display: flex; align-items: center; justify-content: center; height: 100%;">
					<span style="color: #f56c6c; font-size: 26px;">已过期</span>
				</div>
				<center class="cardBox" :key=index :style="{width:item.product.generalBalance == 1 && ifFzjg != 4?'100%':'60%'}">
					<h3 :title="item.product.name">{{item.product.name}}</h3>
					<span v-if="item.product.extraInfo">
						<p class="text" style="color:#999999;text-align: left;" v-if="JSON.parse(item.product.extraInfo).serviceAge">保障年龄：<span v-if="JSON.parse(item.product.extraInfo).serviceAge == 200">无限制</span>
							<span v-else>{{JSON.parse(item.product.extraInfo).serviceAge}}以内</span></p>
					</span>
					<p class="text" style="color:#999999;text-align: left;">
						截止日期：<span v-if="item.validDate">{{ setTime(item.validDate) }}</span>
						<span v-else>--</span>
						<span v-if="item.isExpired" style="color: #f56c6c; margin-left: 10px;">(已过期)</span>
					</p>
          <!-- {{item.product}} -->
					<p class="text" style="color:#999999;text-align: left;" >
            
						剩余张数：<span>{{ item.remainCount || 0 }}张</span>
					</p>
					<span v-if="item.product.productLevel == 2">
						<p v-if="item.product.mainProductJsonpriceModel == 3" style="color: rgb(153, 153, 153);text-align: left;" class="text"><b>费用：<span class="yellow">{{ (item.product.productPlanInfoamount * (item.product.suggestPrice /100) ) / 100}}元</span></b></p>
						<p v-else style="color: rgb(153, 153, 153);text-align: left;" class="text"><b>费用：<span class="yellow">{{item.product.suggestPrice/100}}元</span></b></p>
					</span>
					<span v-else>
						<p style="color: rgb(153, 153, 153);text-align: left;" class="text"><b>费用：<span class="yellow">{{item.product.suggestPrice/100}}元</span></b></p>
					</span>
				</center>
				<div class="img" v-if="item.product.generalBalance != 1 || ifFzjg == 4">
					<div style="text-align: center;margin-bottom: 10px;">
					</div>
				</div>
			</div>
		</div>
		<el-pagination
			style="margin-top:20px;text-align: center;"
			@size-change="handlePreOrderSizeChange"
			@current-change="handlePreOrderCurrentChange"
			:current-page="preOrderCurrentPage"
			:page-sizes="[12]"
			:page-size="preOrderEachPage"
			layout="total, sizes, prev, pager, next, jumper"
			:total="preOrderTotal">
		</el-pagination>
	</template>
	<template v-else-if="tableData.length != 0 && actcolor != 2">
        <div style="background-color: #ffffff;">
          <div class="shopBox" style="margin-left: 20px;" v-for="(item,index) in generalBalance" :key="index">
            <span v-if="item.productCode">
              <ewm  v-show="actcolor == 0" :productCode="item.productCode" :key="time" :index=index :imagePath=imagePath :channelId='channelId' :channelData='channelData' :id='item.id' :productGroup='item.productGroup' :Grouptype='"bbbb"' :subChannelId='subChannelId' :type='item.introHtml'></ewm>
			        <ewm  v-show="actcolor == 1" :productCode="item.productCode" :key="time" :index=index :imagePath=imagePath :channelId='channelId' :channelData='channelData' :id='item.id' :productGroup='item.productGroup' :Grouptype='"bbbb"' :fxyc='"fxyc"'  :subChannelId='subChannelId' :type='item.introHtml'></ewm>
            </span>
            <span v-else>
              <ewm  v-show="actcolor == 0"  :key="time" :index=index :imagePath=imagePath :channelId='channelId' :channelData='channelData' :id='item.id' :productGroup='item.productGroup' :Grouptype='"bbbb"' :subChannelId='subChannelId' :type='item.introHtml'></ewm>
			        <ewm  v-show="actcolor == 1" :key="time" :index=index :imagePath=imagePath :channelId='channelId' :channelData='channelData' :id='item.id' :productGroup='item.productGroup' :Grouptype='"bbbb"' :fxyc='"fxyc"'  :subChannelId='subChannelId' :type='item.introHtml'></ewm>
            </span>
				<!-- <p class="text1 yellow" style="width: 75px;text-align: center;margin-top: -9px;">￥{{item.suggestPrice/100}}元</p> -->
        <center class="cardBox" :key=index :style="{width:item.generalBalance == 1 && ifFzjg != 4?'100%':'60%'}">
				<h3 :title="item.name">{{item.name}}</h3>
        <span v-if="item.extraInfo">
          <p class="text" style="color:#999999;text-align: left;" v-if="JSON.parse(item.extraInfo).serviceAge">保障年龄：<span v-if="JSON.parse(item.extraInfo).serviceAge == 200">无限制</span>
            <span v-else>{{JSON.parse(item.extraInfo).serviceAge}}以内</span></p>
        </span>
   
				<span v-if="item.productLevel == 2">
          <span v-if="item.mainProductJsonpriceModel == 3">
            <p class="text" style="color:#999999;text-align: left;">保障日期：{{item.productPlanInfovalidStart}}
            <span v-if="item.productPlanInfovalidType == 2">月</span>
            <span v-if="item.productPlanInfovalidType == 1">年</span>
            <span v-if="item.productPlanInfovalidType == 3">日</span>
          </p>
        </span>
        <span v-else>
            <p class="text" style="color:#999999;text-align: left;">保障日期：{{item.mainProductJsonperiod}}
            <span v-if="item.mainProductJsonperiodType == 2">月</span>
            <span v-if="item.mainProductJsonperiodType == 1">年</span>
            <span v-if="item.mainProductJsonperiodType == 3">日</span>
          </p>
        </span>
        </span>
          <span v-else>
            <p class="text" style="color:#999999;text-align: left;">保障日期：{{item.period}}
            <span v-if="item.periodType == 2">月</span>
            <span v-if="item.periodType == 1">年</span>
            <span v-if="item.periodType == 3">日</span>
          </p>
        </span>
       
        <span v-if="item.productLevel == 2">

          <p v-if="item.mainProductJsonpriceModel == 3" style="color: rgb(153, 153, 153);text-align: left;" class="text"><b>费用：<span class="yellow">{{ (item.productPlanInfoamount * (item.suggestPrice /100) ) / 100}}元</span></b></p>
          <p v-else style="color: rgb(153, 153, 153);text-align: left;" class="text"><b>费用：<span class="yellow">{{item.suggestPrice/100}}元</span></b></p>
        </span>
        <span v-else>
          <p style="color: rgb(153, 153, 153);text-align: left;" class="text"><b>费用：<span class="yellow">{{item.suggestPrice/100}}元</span></b></p>
        </span>
				
				<!-- <p class="text2">建议售价</p> -->
				<p class="text3">
					<!-- <router-link class="more blue" :to="'/commodity/commodityDetails?id='+item.id+'&channelId='+channelId+'&subChannelId='+subChannelId">签约详情</router-link> -->
					<!-- <router-link v-if='index%2 == 0 ' target="_blank" class="more blue" :to="'/details?index='+0+'&tag=旅行社专属救援清单&status=1'">产品详情</router-link>
					<router-link v-else target="_blank" class="more blue" :to="'/details?index='+1+'&tag=旅行社专属救援清单&status=1'">产品详情</router-link> -->
				</p>
			</center>
    
			<div class="img" v-if="item.generalBalance != 1 || ifFzjg == 4"><!-- 0是否 -->
        <div style="text-align: center;margin-bottom: 10px;">  
        </div>	
      </div>         
		</div>
        </div>
	 		
    <el-pagination
            style="margin-top:20px;text-align: center;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[12]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
	</template>
		<div v-if="tableData.length == 0 && actcolor != 2" class="shopBox testno">
			暂无签约
		</div>
		<div v-if="preOrderProductList.length == 0 && actcolor == 2" class="shopBox testno">
			暂无数据
		</div>
	</div>
</template>

<script>
	import { productList,listchannel,listProductConfig,listPreOrder } from '@/axios/api.js'
	import common from '@/assets/common.js'
  import { Loading } from 'element-ui';
  import axios from 'axios'
	import ewm from './ewm'
	export default {
		data() {
			return {
        time:'',
        eachPage:12, //每页
        indexPage:0, //当前页
        total:0,
        currentPage4: 1,
        name:'',
        productGroup:'',
        productGrouplist:[],
        prestore:localStorage.getItem('prestore'),
        actcolor:0,
        group:'',
				tableData: [],
				preOrderList: [], // 不记名核销列表
				preOrderProductList: [], // 不记名核销处理后的产品列表（去重）
				preOrderTotal: 0, // 不记名核销总数
				preOrderEachPage: 12, // 不记名核销每页
				preOrderIndexPage: 0, // 不记名核销当前页
				preOrderCurrentPage: 1, // 不记名核销当前页码
				preOrderTime: '', // 不记名核销时间戳，用于刷新二维码
				imagePath: require('../../assets/img/logo2.png'),
				channelId: JSON.parse(window.localStorage.getItem("token")).data.obj2.channelId,
				subChannelId: '',
				channelData: [],
				ifFzjg:JSON.parse(window.localStorage.getItem("token")).data.obj.category
			}
		},
		computed:{
			generalBalance(){
				return this.tableData.filter(item =>{
					return item.generalBalance != 1
				})
			}
		},
		methods: {
      handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.getDataList()
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = (val-1) * this.eachPage;
				this.getDataList()
       
			},
      searchFun() {
        this.eachPage = 10; //每页
        this.indexPage = 0; //当前页
         this.getDataList()
      },
      actclick(ind) {
        this.actcolor = ind
        if (ind == 2) {
          // 切换到不记名核销时，获取数据
          this.getPreOrderList()
        }
      },
      /**
       * 获取不记名核销订单列表
       */
      getPreOrderList() {
        var data = {
          start: this.preOrderIndexPage,
          count: this.preOrderEachPage
        }
        listPreOrder(data)
          .then(res => {
            if (res.data.code == 0) {
              // 如果接口返回null或空数组，清空数据
              if (!res.data.obj || res.data.obj.length === 0) {
                this.preOrderList = []
                this.preOrderProductList = []
                this.preOrderTotal = 0
              } else {
                this.preOrderList = res.data.obj || []
                this.preOrderTotal = res.data.total || 0
                // 处理产品数据，按产品去重并格式化
                this.processPreOrderProducts()
              }
            } else {
              // 接口返回错误时，清空数据
              this.preOrderList = []
              this.preOrderProductList = []
              this.preOrderTotal = 0
              this.$message.warning(res.data.msg || '获取数据失败')
            }
          })
          .catch(err => {
            console.log(err)
            // 接口异常时，清空数据
            this.preOrderList = []
            this.preOrderProductList = []
            this.preOrderTotal = 0
            this.$message.error('获取数据失败')
          })
      },
      /**
       * 处理不记名核销产品数据，去重并格式化
       */
      processPreOrderProducts() {
        const productMap = new Map()
        this.preOrderList.forEach(item => {
          if (item.product && item.product.id) {
            // 如果该产品还没添加，则添加
            if (!productMap.has(item.product.id)) {
              // 处理产品数据，类似正常支付列表的处理
              const product = { ...item.product }
              
              // 处理产品级别2的数据
              if (product.productLevel == 2 && product.mainProductJson) {
                try {
                  const mainProductJson = JSON.parse(product.mainProductJson)
                  product.mainProductJsonpriceModel = mainProductJson.priceModel
                  product.mainProductJsonperiod = mainProductJson.period
                  product.mainProductJsonperiodType = mainProductJson.periodType
                  if (mainProductJson.priceModel == 3 && mainProductJson.productPlanInfo) {
                    const productPlanInfo = JSON.parse(mainProductJson.productPlanInfo)
                    if (productPlanInfo[0]) {
                      product.productPlanInfoamount = productPlanInfo[0].amount
                      product.productPlanInfovalidStart = productPlanInfo[0].validStart
                      product.productPlanInfovalidType = productPlanInfo[0].validType
                    }
                  }
                } catch (e) {
                  console.error('解析产品数据错误:', e)
                }
              }
              
              // 判断是否过期
              const currentTime = new Date().getTime()
              const validDate = item.preOrder.validDate
              const isExpired = validDate && validDate < currentTime
              
              // 保存产品信息，同时保存订单的渠道信息和billingId以及validDate和totalCount
              productMap.set(product.id, { 
                product,
                channelId: item.channelId,
                subChannelId: item.subChannelId,
                billingId: item.preOrder.billingId,
                remainCount: item.preOrder.remainCount || 0,
                validDate: validDate,
                isExpired: isExpired,
                totalCount: item.preOrder.totalCount || 0
              })
            }
          }
        })
        
        this.preOrderProductList = Array.from(productMap.values())
        this.preOrderTime = new Date().getTime()
      },
      /**
       * 不记名核销分页 - 每页条数改变
       */
      handlePreOrderSizeChange(val) {
        this.preOrderEachPage = val
        this.preOrderIndexPage = 0
        this.preOrderCurrentPage = 1
        this.getPreOrderList()
      },
      /**
       * 不记名核销分页 - 当前页改变
       */
      handlePreOrderCurrentChange(val) {
        this.preOrderCurrentPage = val
        this.preOrderIndexPage = (val - 1) * this.preOrderEachPage
        this.getPreOrderList()
      },
      /**
       * 格式化时间
       */
      setTime(str) {
        return common.time(str)
      },
			getDataList() {
				//获取渠道
				var data = {
					start: 0,
					count: 500
				}
				listchannel(data)
					.then(res => {
            console.log(res.data,'res.datares.data')
						if (res.data.code == 0) {
							if(res.data.obj.length > 1){
								this.subChannelId = res.data.obj[1].id;
                // console.log(res.data.obj[1].productGroup,'productGroupproductGroup')
                // this.group = res.data.obj[1].productGroup
							}
							this.channelData = res.data.obj;
              var obj = {
                productGroup:this.productGroup, //组编码
                name:this.name, //产品名
                start: this.indexPage,//
                count: this.eachPage
              }
							productList(obj)
								.then(res => {
									if (res.data.code == 0) {
                    this.total = res.data.total
                    for(var i = 0; i< res.data.obj.length; i++) {
                      if(res.data.obj[i].productLevel == 2) {
                        res.data.obj[i].mainProductJsonpriceModel = JSON.parse(res.data.obj[i].mainProductJson).priceModel
                        res.data.obj[i].mainProductJsonperiod = JSON.parse(res.data.obj[i].mainProductJson).period
                        res.data.obj[i].mainProductJsonperiodType = JSON.parse(res.data.obj[i].mainProductJson).periodType
                        if(JSON.parse(res.data.obj[i].mainProductJson).priceModel == 3) {
                          res.data.obj[i].productPlanInfoamount = JSON.parse(JSON.parse(res.data.obj[i].mainProductJson).productPlanInfo)[0].amount
                          res.data.obj[i].productPlanInfovalidStart = JSON.parse(JSON.parse(res.data.obj[i].mainProductJson).productPlanInfo)[0].validStart
                          res.data.obj[i].productPlanInfovalidType = JSON.parse(JSON.parse(res.data.obj[i].mainProductJson).productPlanInfo)[0].validType
                        }
                      }
                    }
                    console.log(res.data.obj)
										this.tableData = res.data.obj;
                    this.time = new Date().getTime()
                    console.log(this.tableData)
                    
									} else {
										this.$message.warning(res.deta.msg);
									}
								})
								.catch(err => {
									console.log(err)
								})
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
      downPdf(){
        var loadingInstance = Loading.service({ fullscreen: true })
        const httpAxios = axios.create();//创建实例
        httpAxios.defaults.timeout = 1000 * 60 * 2;
        httpAxios.get(SEVERS + '1.0/rescue_sale/sale/download_qrcode',{
          params:{
            token:JSON.parse(window.localStorage.getItem("token")).data.obj.token
          }
        })
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            loadingInstance.close();
            window.location=res.data.obj
          }
        })
        .catch(err => {
          console.log(err);
          loadingInstance.close();
        })
      },
		},
		components: {
			ewm
		},
		mounted() {
			this.getDataList()
      var obj = {
        type:1, //1产品组 2产品分类 3职业类别 4清单类型
        start: 0,
        count: 100
      }
      listProductConfig(obj).then((res)=>{
        this.productGrouplist = res.data.obj2.groupLst
        console.log(res)
      })
		}
	}
</script>

<style scoped="scoped">
  .block {
    float: left;
  }
	h3 {
		color: #333;
		font-weight: normal;
		text-align: center;
	}
	.more {
		/* background: url(../../assets/img/more.png) center right no-repeat; */
		/* padding-right: 20px; */
	}

	.cardBox h3 {
		margin-bottom: 20px;
		font-weight: bold;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
	}

	.text1 {
		/* line-height: 60px; */
		font-size: 16px;
		/* margin-top: 10px; */
	}

	.text2 {
		color: #666;
	}

	.text3 {
		margin-top: 10px;
		width: 250px;
		display: flex;
		justify-content:space-around
	}
	.shopBox {
		overflow: hidden;
		/* box-shadow: 0 0 20px rgba(63, 180, 253, 0.2); */
		/* border-radius: 5px; */
		padding: 30px;
		width: 47%;
    height: 208px;
    display: inline-block;
		margin: 0 auto;
		margin-top: 20px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.09);
    border-radius: 2px;
    border: 1px solid #E9E9E9;
    position: relative;
	}

	.cardBox {
		float: left;
		width: 70%;
    position: absolute;
    right: 0px;
    top: 14%;
	}

	.shopBox .img {
		float: left;
		width: 40%;
	}
	.testno{text-align: center;line-height: 200px;}
	.qianyueBox{padding-bottom: 40px;height: calc(100vh - 130px);overflow-y: auto;}
  .act {
    background-color: #00ABFA;
    color:#ffffff
  }
  .id {
  width: 20px;
  height: 20px;
  background-color: #F0F2F5;
  border-radius: 17px;
  text-align: center;
  float: left;
  margin-right: 10px;
}
</style>
<style>
.block input{
     height: 32px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/commodity/index.vue